var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import Responsive from "react-responsive";
var breakpoints = {
    desktop: "769px",
    tablet: "768px",
    mobile: "425px",
};
var Desktop = function (props) { return (React.createElement(Responsive, __assign({}, props, { minWidth: breakpoints.desktop }))); };
var Tablet = function (props) { return (React.createElement(Responsive, __assign({}, props, { maxWidth: breakpoints.tablet }))); };
var Mobile = function (props) { return (React.createElement(Responsive, __assign({}, props, { maxWidth: breakpoints.mobile }))); };
export { Mobile, Tablet, Desktop };
